"use client";

import LazyImage from "@/components/lazyImage/LazyImage";
import Button from "@/components/ui/button/Button";
import Modal from "@/components/ui/modal_new/Modal";
import { useMediaQuery } from "@/hooks/useMediaQuery";

interface IProps {
  open: boolean;
  imgURL?: string;
  onCancel: () => void;
  onConfirm: () => void;
  slots: { cancel: string; confirm: string; title: string };
}

const ConfirmationModal = ({ imgURL, onConfirm, onCancel, open, slots }: IProps) => {
  const isSmallScreen = useMediaQuery("(max-width: 640px)", {
    defaultValue: false,
    initializeWithValue: true,
  });

  return (
    <Modal onClose={onCancel} isOpen={open} slots={{ container: { className: "px-6 pt-4 pb-5" } }}>
      <div className="mt-3 flex flex-col gap-5 sm:mt-0 sm:flex-row">
        {imgURL && (
          <div className="h-[10rem] sm:w-[10rem]">
            <LazyImage
              width={131}
              height={157}
              src={imgURL}
              alt="Prescription image"
              className="h-full w-full object-cover"
            />
          </div>
        )}
        <div className="flex flex-col items-center gap-5 sm:items-start sm:justify-between">
          <h3 className="text-center text-base font-semibold sm:max-w-[13rem] sm:text-left">
            {slots.title}
          </h3>
          <div className="grid grid-cols-2 items-center gap-4">
            <Button
              onClick={onCancel}
              variant={isSmallScreen ? "link" : "outlined"}
              className="col-span-full text-sm sm:col-span-1 md:px-5 md:py-2"
            >
              {slots.cancel}
            </Button>
            <Button
              className="col-span-full row-start-1 text-sm sm:col-span-1 md:px-5 md:py-2"
              onClick={onConfirm}
            >
              {slots.confirm}
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ConfirmationModal;
